import React from "react";
import { Alert, Collapse, Table, Typography } from "antd";
import dayjs from "dayjs";

const { Text, Title } = Typography;
const amount = (value, currency) => value === null || value === undefined
  ? "Indisponible"
  : `${Number(value).toLocaleString("fr-FR", { maximumFractionDigits: 4 })} ${currency || ""}`;

export default function IncomeStatementStockAdjustments({ data, currency = "XOF" }) {
  if (!data) return null;
  return <section aria-label="Incidence des ajustements de stock" style={{ marginTop: 16 }}>
    {data.incomplete && <Alert type="warning" showIcon message="Résultat à compléter"
      description={!data.available ? "La valorisation des ajustements n’est pas active. Leur impact n’est pas inclus dans ce résultat."
        : `À qualifier : ${data.pendingCount || 0}. Sans valeur exploitable : ${data.unvaluedCount || 0}. Autre devise : ${data.currencyMismatchCount || 0}. Ces opérations sont exclues du résultat présenté.`} />}
    <Title level={5}>Incidence des ajustements de stock</Title>
    <Text type="secondary">Ces montants sont déjà inclus dans le résultat d’exploitation, séparément de la marge des ventes.
      Une qualification ultérieure du motif s’applique à la période de l’opération d’origine, au montant enregistré.</Text>
    <Table size="small" rowKey="reason_code" pagination={false} style={{ marginTop: 12 }} scroll={{ x: 620 }}
      dataSource={data.byReason || []} locale={{ emptyText: "Aucun ajustement reconnu dans le résultat de cette période." }}
      columns={[
        { title: "Motif", dataIndex: "label", key: "label" },
        { title: "Charges nettes", dataIndex: "expenses", key: "expenses", align: "right", render: value => amount(value, currency) },
        { title: "Produits nets", dataIndex: "income", key: "income", align: "right", render: value => amount(value, currency) },
        { title: "Impact net", dataIndex: "net_impact", key: "net_impact", align: "right", render: value => amount(value, currency) },
      ]} />
    {data.review?.length > 0 && <Collapse style={{ marginTop: 12 }} items={[{
      key: "review", label: `Ajustements exclus du résultat (${data.review.length}${data.reviewTruncated ? "+" : ""})`,
      children: <>
        {data.reviewTruncated && <Text type="secondary">Échantillon limité à 200 événements ; les compteurs couvrent toute la période.</Text>}
        <Table size="small" rowKey="event_id" pagination={{ pageSize: 10 }} scroll={{ x: 720 }} dataSource={data.review}
          columns={[
            { title: "Ajustement", dataIndex: "adjustment_id", key: "adjustment_id" },
            { title: "Date", dataIndex: "date", key: "date", render: value => value ? dayjs(value).format("DD/MM/YYYY HH:mm") : "Indisponible" },
            { title: "Motif", dataIndex: "reason", key: "reason" },
            { title: "Valeur enregistrée", key: "value", render: (_, row) => amount(row.stock_value_delta, row.currency) },
            { title: "Situation", dataIndex: "label", key: "label" },
          ]} />
      </>,
    }]} />}
  </section>;
}
